/* eslint-disable sort-keys */
import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {modalConfirm} from 'app/utils/modals/popups';
import Checkbox from 'app/components/auth/Checkbox';
import Post from 'app/utils/Post';
import {toastError, toastInfo} from 'app/components/toasts/liteToast';
import {CooloffInterface} from 'app/interfaces/UserInterface';
import SmartSelect from 'app/components/reusable/SmartSelect';

interface RowCoolingOffProps {
  rowClass: string;
  errorHint: ReactNode;
  cool_off?: CooloffInterface;
}

interface RowCoolingOffState {
  disabled: boolean;
  marketingActivity: boolean;
  selectedDuration: string;
  selectedSection: string;
}

export class RowCoolingOff extends Component<RowCoolingOffProps, RowCoolingOffState> {
  state: RowCoolingOffState = {
      disabled: false,
      marketingActivity: false,
      selectedDuration: '24_hours',
      selectedSection: 'all_products'
  };

  COOL_OFF_PERIODS: Record<string, string> = {
      '24_hours': I18n.t('24_hours'),
      one_week: I18n.t('1_week'),
      one_month: I18n.t('1_month'),
      three_months: I18n.t('3_months')
  };

  SITE_SECTIONS: Record<string, string> = {
      all_products: I18n.t('cooling_off_all_products'),
      cybersport_bets: I18n.t('cooling_off_cybersport_bets'),
      sports_bets: I18n.t('cooling_off_sportsbook'),
      casino: I18n.t('cooling_off_casino'),
      poker: I18n.t('cooling_off_poker'),
      lootboxes: I18n.t('cooling_off_lootboxes')
  };

  componentDidMount(): void {
      const {cool_off} = this.props;

      if (cool_off) {
          this.setState({
              marketingActivity: Boolean(cool_off.marketing_activity),
              selectedDuration: cool_off.period || '24_hours',
              selectedSection: cool_off.product_type || 'all_products'
          });
      }
  }

  componentDidUpdate(prevProps: RowCoolingOffProps): void {
      const {cool_off} = this.props;

      if (cool_off && cool_off !== prevProps.cool_off) {
          this.setState({
              marketingActivity: Boolean(cool_off.marketing_activity),
              selectedDuration: cool_off.period || '24_hours',
              selectedSection: cool_off.product_type || 'all_products'
          });
      }
  }

  coolingOff = (event: React.MouseEvent): void => {
      event.preventDefault();

      const selectedText = this.COOL_OFF_PERIODS[this.state.selectedDuration];

      modalConfirm(
          {
              element:
        <form onSubmit={this.doCoolingOff}>
            <div
                dangerouslySetInnerHTML={{
                    __html: I18n.t('cooling_off_message', {
                        date: selectedText || ''
                    })
                }}
            />
        </form>,
              react: true
          },
          this.doCoolingOff,
          null,
          {
              cancelText: I18n.t('no'),
              okText: I18n.t('confirm'),
              setFocus: false
          }
      );
  };


  doCoolingOff = (event: React.FormEvent<HTMLFormElement>): void => {
      event && event.preventDefault();
      this.setState({disabled: true});
      new Post({
          params: {
              marketing_activity: this.state.marketingActivity,
              period: this.state.selectedDuration,
              product_type: this.state.selectedSection
          },
          url: '/egb_users/cool_off'
      })
          .execute()
          .then(response => response.json())
          .then(response => {
              if (response.success) {
                  toastInfo(response.message);
              } else {
                  toastError(response.message);
                  this.setState({disabled: false});
              }
          });
  };

  handleMarketingActivityChange = (checked: boolean): void => {
      this.setState({marketingActivity: checked});
  };

  handleDurationChange = (value: string): void => {
      this.setState({selectedDuration: value as string});
  };

  handleSectionChange = (value: string): void => {
      this.setState({selectedSection: value as string});
  };

  showCooloffEnddate = (): ReactNode => <div>
      <p className="cooling-off-enddate">
          {I18n.t('cooloff_valid_till', {
              product: I18n.t(`cooling_off_${this.props.cool_off?.product_type}`).toLowerCase(),
              date: this.props.cool_off?.end_date
          })}
      </p>
  </div>;

  render(): ReactNode {
      const {rowClass, errorHint, cool_off} = this.props;
      const {disabled, marketingActivity} = this.state;
      return (
          <div className={`${rowClass} cooling-off__row`}>
              <div className={`field-description${cool_off?.present ? ' field-description--disabled' : ''}`}>
                  <p>{I18n.t('take_short_break_betting')}</p>
              </div>
              <div className="field cooling-off-selects">
                  <label className="field-label" htmlFor="cooling-off-duration">
                      {I18n.t('duration_period')}
                  </label>
                  <SmartSelect
                      id="cooling-off-duration"
                      value={this.state.selectedDuration}
                      onChange={this.handleDurationChange}
                      collection={Object.entries(this.COOL_OFF_PERIODS).map(([k, v]) => ({
                          value: k,
                          text: v,
                          text2: ''
                      }))}
                      disabled={cool_off.present || disabled}
                  />
              </div>
              <div className="field cooling-off-selects">
                  <label className="field-label" htmlFor="cooling-off-sections">
                      {I18n.t('site_sections')}
                  </label>
                  <SmartSelect
                      id="cooling-off-sections"
                      value={this.state.selectedSection}
                      onChange={this.handleSectionChange}
                      collection={Object.entries(this.SITE_SECTIONS).map(([k, v]) => ({
                          value: k,
                          text: v,
                          text2: ''
                      }))}
                      disabled={cool_off.present || disabled}
                  />
              </div>
              <Checkbox
                  value={marketingActivity}
                  key="uesms"
                  name="unsubscribing_email_sms"
                  checked={marketingActivity || cool_off?.marketing_activity}
                  onChange={this.handleMarketingActivityChange}
                  nameInputCheckbox="checkbox_unsubscribing_email_sms"
                  label={I18n.t('complete_optout_email')}
                  disabled={cool_off.present || disabled}
              />
              {errorHint}
              { cool_off?.present
                  ? this.showCooloffEnddate()
                  : <button
                      className="button-adaptive"
                      onClick={this.coolingOff}
                      disabled={cool_off.present || disabled}>
                      {I18n.t('take_break')}
                  </button>}
          </div>
      );
  }
}
